import app from '../app';
import classList from '../utils/classList';
import applyIconStyle from '../utils/applyIconStyle';
import Component from '../Component';
export default class Icon extends Component {
  view(vnode) {
    const {
      name,
      noStyleOverride,
      ...attrs
    } = vnode.attrs;

    // Admins can force every icon to a particular FontAwesome style
    // (e.g. `fa-duotone fa-light`); empty means icons render as declared.
    const forcedStyle = noStyleOverride ? null : app?.forum?.attribute('fontAwesomeForcedStyle');

    // @ts-ignore
    attrs.className = classList('icon', forcedStyle ? applyIconStyle(name, forcedStyle) : name, attrs.className);
    return m("i", Object.assign({
      "aria-hidden": "true"
    }, attrs));
  }
}
flarum.reg.add('core', 'common/components/Icon', Icon);